import React, { useState } from 'react';
import { graphql } from 'gatsby';
import _ from 'lodash';

import SEO from '../components/seo';
import Wrapper from '../containers/wrapper';
import SessionData from '../components/session-data';
import TeamTeaser from '../components/chinaTeam-teaser';
import CompanyTeaser from '../components/chinaCompany-teaser';
import ChinaFooter from '../components/chinaFooter';
// import { buildImageObj, imageUrlFor } from '../components/sanity/image-url';
import ReactMarkdown from 'react-markdown/with-html';

export const query = graphql`
    query ChinaHomeTemplateQuery {
        site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
            title
            description
            keywords
        }
        home: sanityChinaHome {
            id
            title {
                en
                cn
            }
            description {
                cn
                en
            }
            teamTitle {
                cn
                en
            }
            companiesTitle {
                cn
                en
            }
            address1 {
                cn
                en
            }
            address2 {
                en
                cn
            }
            footerBlurb {
                cn
                en
            }
        }
        team: allSanityChinaTeam(sort: {order: ASC, fields: publishedAt}) {
            edges {
              node {
                id
                name {
                  cn
                  en
                }
                previewImage {
                  asset {
                    _id
                    url
                  }
                }
                slug {
                  current
                }
              }
            }
        }
        companies: allSanityCompany(filter: {categories: {elemMatch: {categoryTitle: {eq: "China"}}}}) {
            edges {
              node {
                logo {
                  asset {
                    _id
                    url
                  }
                }
                companyUrl
                slug {
                    current
                }
              }
            }
        }
    }
`;

const ChinaHomeTemplate = props => {
    const sessionLanguage = SessionData.getValue('language') || 'en';
    const [language, setLanguage] = useState(sessionLanguage);
    const { data } = props;
    const home = _.get(data, 'home');
    const team = _.get(data, 'team');
    const companies = _.get(data, 'companies');

    const languages = {
        'en': {
            'changeLang': 'cn',
            'changeLabel': 'View in Chinese'
        },
        'cn': {
            'changeLang': 'en',
            'changeLabel': 'View in English'
        },
    }

    if (!home) {
        throw new Error('Missing data');
    }

    const toggleLanguage = (currentLanguage) => {
        setLanguage(currentLanguage);
        SessionData.setValue('language', currentLanguage);
    }

    return (
        <Wrapper>
        <SEO title={home.title[language]} defaultMicroData={true} />
        <a id="langSelect" onClick={() => toggleLanguage(languages[language].changeLang)}>{languages[language].changeLabel}</a>
        <div className="container">
            <div className="row justify-content-start headline-aux">
                <div className="col-12">
                    <header className="page-heading">
                        <h1><strong className="headline__headline">{home.title[language]}</strong></h1>
                    </header>

                    {home.description && <ReactMarkdown source={home.description[language]} />}

                    <div className="team">
                        <h2 style={{margin: '50px 0 30px'}}>{home.teamTitle[language]}</h2>
                        <div className="row">
                        {team.edges && team.edges.map((person, personIndex) => (
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={personIndex}>
                                <TeamTeaser {...person.node} language={language} />
                            </div>
                        ))}
                        </div>
                    </div>

                    <div className="companies">
                        <h2 style={{margin: '50px 0 30px'}}>{home.companiesTitle[language]}</h2>
                        <div className="row">
                        {companies.edges && companies.edges.map((company, companyIndex) => (
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={companyIndex}>
                                <CompanyTeaser {...company.node} />
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ChinaFooter language={language} data={data} />
        </Wrapper>
    );
};

export default ChinaHomeTemplate;
